module.exports = __webpack_public_path__ + "70bf73ac99dc0ae9bf5d52ed26f1706b.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/1.png
// module id = 293
// module chunks = 0